import { Container } from './RuleInfo.styles'
import { RuleInfoProps } from './RuleInfo.types'
import { RuleSection } from './RuleSection'

const RuleInfo = ({
    conditions,
    actions,
    dataTestId = 'rule-info',
}: RuleInfoProps) => {
    return (
        <Container data-testid={dataTestId}>
            <RuleSection
                title="CONDITIONS"
                items={conditions}
                dataTestId={`${dataTestId}-conditions-section`}
            />
            <RuleSection
                title="ACTIONS"
                items={actions}
                dataTestId={`${dataTestId}-actions-section`}
            />
        </Container>
    )
}

export default RuleInfo
